export default __webpack_public_path__ + "static/media/mutate-alex-3.7e1f415c.png";